import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@gasbuddy/react-components';
import Modal from '../modal';
import ActionLink from '../action-link';
import styles from './styles.css';
import sharedStyles from '../../styles/shared.css';

const { getSupportEmail } = require('../../../lib/bputils').default;

const TITLE = 'Help & Resources';

export default function HelpResourcesLink({ className, hideText }) {
  const supportEmail = getSupportEmail();

  const helpAndResourcesButton = (
    <span>
      <ActionLink
        imagePath="/images/app/icon_help_default.svg"
        hoverImagePath="/images/app/icon_help_active.svg"
        imageAlign="left"
        linkText={TITLE}
        hideText={hideText}
        customClasses={sharedStyles.white}
      />
    </span>
  );

  return (
    <Modal
      className={className}
      size="sm"
      button={helpAndResourcesButton}
      hideHeaderSeparator
      gTagTitle={`${TITLE} Popup`}
    >
      <>
        <Text className={sharedStyles.titleText}>
          {TITLE}
        </Text>
        <br />
        <br />
        <Text className={sharedStyles.secondaryText}>
        We&#39;re dedicated to your success, and we&#39;re here to do everything we can to
        help you get the most from GasBuddy Business Pages. Here are a few ways we can help:
        </Text>
        <br />
        <br />
        <div className={styles.helpAndResources}>
          <Text className={sharedStyles.headerText}>
          Training &amp; Success
          </Text>
          <br />
          <Text className={sharedStyles.secondaryText}>
          Want to know how to use a new feature? Maybe it has been awhile since you last
          signed in? Check out our Training and Success resources to get you up to speed
          on everything Business Pages related.
          </Text>
          <br />
          <a className={styles.floatRight} rel="noopener noreferrer" target="_blank" href="https://www.gasbuddy.com/go/business-support-page">Go to Training &amp; Success resources &gt;</a>

          <br />
          <br />
          <Text className={sharedStyles.headerText}>
          Publications &amp; Reports
          </Text>
          <br />
          <Text className={sharedStyles.secondaryText}>
          We are frequently posting articles, reports, and blog posts with tips, foot
          traffic insights, and more to help you grow your business. Feel free to
          visit our Publications page for more information.
          </Text>
          <br />
          <a className={styles.floatRight} rel="noopener noreferrer" target="_blank" href="https://business.gasbuddy.com/publications/">Go to Publications &amp; Reports &gt;</a>

          <br />
          <br />
          <Text className={sharedStyles.headerText}>
          Help
          </Text>
          <br />
          <Text className={sharedStyles.secondaryText}>
          Still can&#39;t find what you&#39;re looking for? Reach out to
            {' '}
            <a rel="noopener noreferrer" href="mailto:{supportEmail}">{supportEmail}</a>
            {' '}
          for assistance.
          </Text>
          <br />
          <a className={styles.floatRight} rel="noopener noreferrer" href={`mailto:${supportEmail}`}>Write to us for help &gt;</a>
        </div>
      </>
    </Modal>
  );
}

HelpResourcesLink.propTypes = {
  className: PropTypes.string,
  hideText: PropTypes.bool,
};

HelpResourcesLink.defaultProps = {
  className: '',
  hideText: false,
};
